import { useEffect } from 'react';
import { AsyncRenderer } from '@client/new/components/AsyncRenderer/AsyncRenderer';
import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { useGetInfluencerQuery } from 'generated/graphql';
import auth from '@client/components/auth';
import { PATHS } from '@client/routes';
import { navigate } from '@client/new/helpers/history';
import { useOnboardingViewModel } from './view-model/Onboarding.viewModel';
import { isEligibleForOnboarding } from './model/onboardingEligibility';
import { OnboardingView } from './view/Onboarding.view';
import { OnboardingLoader } from './view/components/OnboardingLoader';

export const OnboardingPage = () => {
  const influencerId = useInfluencerId();
  const influencerQuery = useGetInfluencerQuery({
    variables: { id: influencerId },
    skip: !influencerId,
  });

  const creatorCreatedAt = influencerQuery.data?.creator?.createdAt ?? null;

  useEffect(() => {
    if (!influencerQuery.data) return;

    if (!isEligibleForOnboarding(creatorCreatedAt)) {
      const homePath = auth.isInfluencer()
        ? PATHS.HOME
        : PATHS.HOME_CREATOR(influencerId);
      navigate(homePath);
    }
  }, [influencerQuery.data, creatorCreatedAt, influencerId]);

  const vm = useOnboardingViewModel(creatorCreatedAt);

  return (
    <AsyncRenderer
      data={vm}
      loadRender={<OnboardingLoader />}
      renderer={(data) => <OnboardingView {...data} />}
    />
  );
};
